module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.640/icons/Warning.svg"